import { render, staticRenderFns } from "./root.vue?vue&type=template&id=19acc81d&scoped=true&"
import script from "./root.ts?vue&type=script&lang=ts&"
export * from "./root.ts?vue&type=script&lang=ts&"
import style0 from "./root.vue?vue&type=style&index=0&id=19acc81d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19acc81d",
  null
  
)

export default component.exports